module.exports = __webpack_public_path__ + "static/donate-74a917b12415164295f583e26c62508f.png";